<template>
    <div class="followUp">
        <div v-if="followList && followList.length > 0" class="followUp_list">
            <div class="followUp_list_content" v-for="item in followList">
                <div class="list_content_date">
                    <span class="date">{{item.date}}</span>
                    <span :class= "item.scheduleDate? 'gray' : 'red'">{{item.scheduleDate ? "已结束" : "未开始"}}</span>
                </div>
                <div class="list_content_case">
                    <p class="case_followUp">前列腺癌随访</p>
                    <div class="followUp_details">
                        <span class="followUp_doctor">就诊医生：{{item.employee.name}}</span>
                        <span class="followUp_record" @click="goDetails(item.id)" v-if="item.scheduleDate">查看随访记录</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="followList.length==0" class="followUp_empty">
            <div class="content">
                <img src="../../assets/images/followUp/followUp.png" />
                <p class="text">没有随访记录</p>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { base } from '@/apis'
  import hosts from '@/apis/hostConfig'
  import getDate from '@/common/getDate'
  export default {
    data(){
      return {
          followList: [],
        }
    },
    created(){
      this.list();
    },
    mounted(){
    },
    computed:mapState({
      openid: state => state.openid,
      hasBinded: state => state.hasBinded,
      uuid: state => state.uuid,
    }),
    methods: {
        goDetails(id) {
            this.$router.push({
                path: '/followUpDetails',
                query: {
                    id: id
                }
            })
        },
        list() {
          if(!this.hasBinded) { // 未绑定个人信息v// 跳转个人信息页面绑定信息
            this.$router.push({
              path: '/goBind'
            })
          } else {
            this.axios.get(base.proxyGet,{
              params:{
                url:hosts[process.env.NODE_ENV].emr+'/Patients/'+this.uuid+'/followUpHistoriesDetail'
              }
            }).then((res)=>{
              if(res.status==200 && res.data.code=='000000'){
                let data = JSON.parse(res.data.data);
                this.followList = data.data.data;
                console.log(this.followList)
              }
            })
          }
        }
    }
  }
</script>

<style scoped lang="scss">
.followUp {
    background: #f8f8f8;
    @include width_height_100();
    .followUp_list {
        padding: 15px 15px 27px;
        .followUp_list_content {
            width: 345px;
            background: #fff;
            border-radius: 6px;
            margin-bottom: 15px;
            .list_content_date {
                height: 40px;
                line-height: 40px;
                padding: 0 15px;
                border-bottom: 1PX solid #f0f0f0;
                position: relative;
                font-size: 13px;
                color: #999;

                .red,.gray {
                    font-size: 16px;
                    position: absolute;
                    right: 15px;
                    top:0;
                }
                .red {
                    color: #ff7272;
                }
                .gray {
                    color: #B2B2B2;
                }
            }
            .list_content_case {
                padding: 0 15px;
                .case_followUp {
                    height: 16px;
                    line-height: 16px;
                    font-size: 16px;
                    color: #333;
                    margin-top: 20px;
                }
                .followUp_details {
                    height: 48px;
                    line-height: 48px;
                    display: flex;
                    .followUp_doctor {
                        height: 48px;
                        line-height: 40px;
                        font-size: 13px;
                        color: #999;
                        flex: 1;
                    }
                    .followUp_record {
                        width: 90px;
                        height: 25px;
                        line-height: 25px;
                        border: 1PX solid #A0DBD3;
                        font-size: 12px;
                        color: #41B7A7;
                        border-radius: 2px;
                        text-align: center;
                    }
                }
            }
        }
    }
    .followUp_empty {
        background: #fff;
        width: 100%;
        height: 100%;
        overflow: hidden;
        .content {
            padding-top: 111px;
            img {
                width: 150px;
                height:150px;
                margin: 0 auto;
            }
            .text {
                width: 100px;
                height: 21px;
                line-height: 21px;
                font-size: 15px;
                color: #999;
                margin: 0 auto;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/followUp/followUp.vue